export default ({ request }) => ({

  detailDesignElementsDictionaryApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionary/detail',
      method: 'post',
      data
    })
  },
  listDesignElementsDictionaryApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionary/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsDictionaryApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionary/save',
      method: 'post',
      data
    })
  },
  delDesignElementsDictionaryApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionary/del',
      method: 'post',
      data
    })
  },
  listDesignElementsDictionaryTypeApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionaryType/list',
      method: 'post',
      data
    })
  },
  saveDesignElementsDictionaryTypeApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionaryType/save',
      method: 'post',
      data
    })
  },
  detailDesignElementsDictionaryTypeApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionaryType/detail',
      method: 'post',
      data
    })
  },
  delDesignElementsDictionaryTypeApi(data) {
    return request({
      url: '/digitalCenter/designElementsDictionaryType/del',
      method: 'post',
      data
    })
  },
})
